
export const calculateAccuracy = (forecast: number, actual: number): string => {
  if (actual === 0) return "N/A";
  return (forecast / actual * 100).toFixed(2) + "%";
};

export const formatNumberWithCommas = (value: number | null): string => {
  if (value === null) return "";
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const formatCurrency = (value: number) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    notation: 'compact',
    maximumFractionDigits: 1
  }).format(value);
};
